<template>
  <div class="animated fadeIn">
    <Row :gutter="20">
      <i-col :xs="12" :md="8" :lg="4" v-for="(infor, i) in inforCardData" :key="`infor-${i}`" style="height: 120px;padding-bottom: 10px;">
        <infor-card shadow :color="infor.color" :icon="infor.icon" :icon-size="36">
          <count-to :end="infor.count" count-class="count-style"/>
          <p>{{ infor.title }}</p>
        </infor-card>
      </i-col>
    </Row>
    <Tabs type="card">
      <TabPane label="小时统计报表">
        <mem-hourly></mem-hourly>
      </TabPane>
      <TabPane label="日统计报表"><mem-daily></mem-daily></TabPane>
      <TabPane label="月统计报表">月统计报表</TabPane>
      <TabPane label="年统计报表">年统计报表</TabPane>
    </Tabs>
  </div>
</template>

<script>

  import echarts from 'echarts'

  import MemHourly from '@/view/ops/components/mem-hourly'
  import MemDaily from '@/view/ops/components/mem-daily'

  import Vue from 'vue'
  import store from '@/store'
  import {mapActions} from 'vuex'
  import {genQueryParam, genSortParam} from '@/libs/queryparamhelper'
  import {numberFormat} from '@/libs/numberutil'
  import InforCard from '_c/info-card'
  import CountTo from '_c/count-to'



  export default {
    //此名称与routers.js中name一致方可缓存
    name: 'systeminfo',
    components: {
      InforCard,
      CountTo,
      echarts,
      MemHourly,
      MemDaily
    },
    data() {
      return{

        refreshTimer:null,
        inforCardData: [
          { title: 'CPU使用率(%)', icon: 'md-calculator', count: 0, color: '#2d8cf0' },
          { title: '内存总量', icon: 'md-copy', count: 0, color: '#19be6b' },
          { title: '内存使用量', icon: 'md-copy', count: 0, color: '#19be6b' },
          { title: '内存空闲量', icon: 'md-copy', count: 0, color: '#19be6b' },
          { title: '磁盘总容量', icon: 'md-copy', count: 0, color: '#19be6b' },
          { title: '磁盘空闲量', icon: 'md-copy', count: 0, color: '#19be6b' },
          { title: '磁盘可用量', icon: 'md-copy', count: 0, color: '#19be6b' },
          { title: '磁盘使用量', icon: 'md-copy', count: 0, color: '#19be6b' },
          // { title: '新增问答', icon: 'md-help-circle', count: 142, color: '#ff9900' },
          // { title: '分享统计', icon: 'md-share', count: 657, color: '#ed3f14' },
          // { title: '新增互动', icon: 'md-chatbubbles', count: 12, color: '#E46CBB' },
          // { title: '新增页面', icon: 'md-map', count: 14, color: '#9A66E4' }
        ],
      }
    },
    methods:{
      ...mapActions([
        'SystemInfoServ_GetSystemInfo'
      ]),
      getSystemInfo(){
        store.dispatch('SystemInfoServ_GetSystemInfo', {
          params: null,
          urlparams: null
        }).then(() => {
          let systemInfo = store.getters.get_SystemInfo_GetSystemInfoResult
          if(systemInfo){
            this.inforCardData[0].count = systemInfo.cpuUsePercent===null?0:systemInfo.cpuUsePercent
            this.inforCardData[1].count = systemInfo.memTotal===null?0:systemInfo.memTotal
            this.inforCardData[2].count = systemInfo.memUsed===null?0:systemInfo.memUsed
            this.inforCardData[3].count = systemInfo.memFree===null?0:systemInfo.memFree
            this.inforCardData[4].count = systemInfo.diskTotal===null?0:systemInfo.diskTotal
            this.inforCardData[5].count = systemInfo.diskFree===null?0:systemInfo.diskFree
            this.inforCardData[6].count = systemInfo.diskAvail===null?0:systemInfo.diskAvail
            this.inforCardData[7].count = systemInfo.diskUsed===null?0:systemInfo.diskUsed
          }
        }).catch(err => {
          this.$Message.error(err)
        })
      }
    },
    mounted() {
      this.$nextTick(() => {
        this.getSystemInfo()
        this.refreshTimer = setInterval(this.getSystemInfo, 5000)

      })
    },
    destroyed() {
      if (this.refreshTimer) {
        clearInterval(this.refreshTimer);
        this.refreshTimer = null;
      }
    }
  }
</script>


